/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 /Users/jay/Documents/dev/threejs-challenge/cozy-place/public/models/anim_roy.glb -o /Users/jay/Documents/dev/threejs-challenge/cozy-place/public/models/anim_roy.tsx --types 
*/

import * as THREE from 'three';
import React, { useEffect, useMemo } from 'react';
import { useGraph, type ThreeElements } from '@react-three/fiber';
import { useGLTF, useAnimations } from '@react-three/drei';
import { SkeletonUtils, type GLTF } from 'three/examples/jsm/Addons.js';
import { useAnimationStore } from 'bvhecctrl';

type ActionName = 'walk';

interface GLTFAction extends THREE.AnimationClip {
  name: ActionName;
}

type GLTFResult = GLTF & {
  nodes: {
    Cube006: THREE.SkinnedMesh;
    Cube006_1: THREE.SkinnedMesh;
    Cube006_2: THREE.SkinnedMesh;
    face_select: THREE.Bone;
    ['DEF-spine']: THREE.Bone;
    ['DEF-pelvisL']: THREE.Bone;
    ['DEF-pelvisR']: THREE.Bone;
    ['DEF-thighL']: THREE.Bone;
    ['DEF-thighR']: THREE.Bone;
    ['DEF-shoulderL']: THREE.Bone;
    ['DEF-upper_armL']: THREE.Bone;
    ['DEF-shoulderR']: THREE.Bone;
    ['DEF-upper_armR']: THREE.Bone;
  };
  materials: {
    m_face: THREE.MeshStandardMaterial;
    Body: THREE.MeshStandardMaterial;
    ['glow-hand']: THREE.MeshStandardMaterial;
  };
  animations: GLTFAction[];
};

export function Roy(props: ThreeElements['group']) {
  const group = React.useRef<THREE.Group>(null!);
  const { scene, animations } = useGLTF('/models/idle_roy-transformed.glb');
  const clone = React.useMemo(() => SkeletonUtils.clone(scene), [scene]);
  const { nodes, materials } = useGraph(clone) as unknown as GLTFResult;
  const { actions } = useAnimations(animations, group);

  /**
   * animation setup
   */
  const animationStatus = useAnimationStore((state) =>
    state.animationStatus.toLocaleLowerCase()
  );

  const animationSet = useMemo(() => {
    return {
      IDLE: 'idle',
      WALK: 'walk',
    };
  }, []);
  useEffect(() => {
    const key = animationStatus ?? animationSet.IDLE;
    const action = key ? actions[key] : null;

    if (!action) return;
    action.reset().fadeIn(0.2).play().timeScale = 1.3;

    // action.getMixer().addEventListener('finished', () => resetAnimation());
    //clean up
    return () => {
      //fade out previous action
      action.fadeOut(0.2);

      // action.getMixer().removeEventListener('finished', () => resetAnimation());

      //@ts-expect-error mixer
      action._mixer._listeners = [];
    };
  }, [actions, animationSet.IDLE, animationStatus]);

  return (
    <group ref={group} {...props} dispose={null}>
      <group name='Scene'>
        <group name='rig003'>
          <primitive object={nodes.face_select} />
          <primitive object={nodes['DEF-spine']} />
          <primitive object={nodes['DEF-pelvisL']} />
          <primitive object={nodes['DEF-pelvisR']} />
          <primitive object={nodes['DEF-thighL']} />
          <primitive object={nodes['DEF-thighR']} />
          <primitive object={nodes['DEF-shoulderL']} />
          <primitive object={nodes['DEF-upper_armL']} />
          <primitive object={nodes['DEF-shoulderR']} />
          <primitive object={nodes['DEF-upper_armR']} />
          <group name='Head003'>
            <skinnedMesh
              name='Cube006'
              geometry={nodes.Cube006.geometry}
              material={materials.m_face}
              skeleton={nodes.Cube006.skeleton}
              castShadow
              receiveShadow
            />
            <skinnedMesh
              name='Cube006_1'
              geometry={nodes.Cube006_1.geometry}
              material={materials.Body}
              skeleton={nodes.Cube006_1.skeleton}
              castShadow
              receiveShadow
            />
            <skinnedMesh
              name='Cube006_2'
              geometry={nodes.Cube006_2.geometry}
              material={materials['glow-hand']}
              skeleton={nodes.Cube006_2.skeleton}
              castShadow
              receiveShadow
            />
          </group>
        </group>
      </group>
    </group>
  );
}

useGLTF.preload('/models/idle_roy-transformed.glb');
